module.exports = __webpack_public_path__ + "static/1b-f136568d5e5fe0a021173d0e55435369.jpg";